import React from 'react';

// Events
import PenaltyShotGoal from './Goal';
import PenaltyShotMissed from './ShotMissed';
import PenaltyShotSaved from './ShotSaved';
import Unknown from '../Unknown';


function determineEventComponent({ result: { type }}){
  switch(type){
    case 'goal':
      return PenaltyShotGoal;
    case 'shotSaved':
      return PenaltyShotSaved;
    case 'shotMissed':
      return PenaltyShotMissed;
    default:
      return Unknown;
  }
}


function PenaltyShotEvents(props) {
  const Component = determineEventComponent(props.event)
  return <Component {...props} />
}

export default PenaltyShotEvents;
